import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {OccEndpointsService} from "@spartacus/core";
import {ClientProgram} from "../interfaces/ClientProgram";
import {HasContract} from "../interfaces/HasContract";

@Injectable({
  providedIn: 'root'
})
export class GonvarriClientProgramAdapter {

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  public getUserHasContract(): Observable<HasContract> {
    return this.http
      .get<HasContract>(
        this.getHasContractUrl(),
        {}
      )
  }

  public getCurrentClientProgram(): Observable<ClientProgram> {
    return this.http
      .get<ClientProgram>(
        this.getAddToCartUrl(),
        {}
      )
  }

  private getAddToCartUrl(): string {
    const queryParams = {}
    return this.occEndpointsService.buildUrl(`/gonvarri/products/clientProgram`, {
      queryParams
    })
  }

  private getHasContractUrl(): string {
    const queryParams = {}
    return this.occEndpointsService.buildUrl(`/hasContract`, {
      queryParams
    })
  }

}
